// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2G0GG","footer":"Form_footer__1mkLb"};